/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ bundle: NonNullable<unknown> }} Profile_Version_BundleInputs */

const en_us2_profile_version_bundle = /** @type {(inputs: Profile_Version_BundleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bundle ${i?.bundle}`)
};

const pt_br2_profile_version_bundle = /** @type {(inputs: Profile_Version_BundleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pacote ${i?.bundle}`)
};

const es_419_profile_version_bundle = /** @type {(inputs: Profile_Version_BundleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Paquete ${i?.bundle}`)
};

const pt_pt2_profile_version_bundle = /** @type {(inputs: Profile_Version_BundleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pacote ${i?.bundle}`)
};

const fr_fr2_profile_version_bundle = /** @type {(inputs: Profile_Version_BundleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bundle ${i?.bundle}`)
};

const de_de2_profile_version_bundle = /** @type {(inputs: Profile_Version_BundleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bundle ${i?.bundle}`)
};

const it_it2_profile_version_bundle = /** @type {(inputs: Profile_Version_BundleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pacchetto ${i?.bundle}`)
};

/**
* | output |
* | --- |
* | "Bundle {bundle}" |
*
* @param {Profile_Version_BundleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_version_bundle = /** @type {((inputs: Profile_Version_BundleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Version_BundleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_version_bundle(inputs)
	if (locale === "es-419") return es_419_profile_version_bundle(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_version_bundle(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_version_bundle(inputs)
	if (locale === "de-DE") return de_de2_profile_version_bundle(inputs)
	if (locale === "it-IT") return it_it2_profile_version_bundle(inputs)
	return en_us2_profile_version_bundle(inputs)
});
export { profile_version_bundle as "profile.version_bundle" }